import { ref } from "vue";
import { getWechatTicket } from "@/api/api";
import wx from 'weixin-js-sdk';


// 🔹 初始化微信分享
export const useWeChatShare = (shareData) => {
  const isReady = ref(false);

  const initWeChatShare =  () => {
      getWechatTicket("?url="+shareData.link).then(res => {
            console.log(res.data);
            const nonceStr = res.data.nonceStr;
            const timestamp = res.data.timestamp;
            const signature = res.data.signature;
            const appId = res.data.appId;
            console.log("signature:"+signature);
            console.log("nonceStr:"+nonceStr);
            console.log("timestamp:"+timestamp);
            console.log("appId:"+appId);
            wx.config({
                debug: false,
                appId: res.data.appId,
                timestamp: res.data.timestamp,
                nonceStr: res.data.nonceStr,
                signature: res.data.signature,
                jsApiList: [
                    'updateAppMessageShareData', // 分享到朋友
                    'updateTimelineShareData', // 分享到朋友圈
                  ]
            });
            wx.error((err) => {
                  console.error("微信 JSSDK 错误111", err);
                  isReady.value = false;
            });
            wx.ready(() => {
              console.log("微信 JSSDK 初始化开始");

              // ✅ 分享给朋友（新 API）
                wx.updateAppMessageShareData({
                  title: shareData.title,
                  desc: shareData.desc,
                  link: shareData.link,
                  imgUrl: shareData.imgUrl,
                  success: () => console.log("分享给朋友配置成功"),
                  fail: (err) => console.log("❌ 朋友分享配置失败",err),
                });

              // ✅ 分享到朋友圈（新 API）
                wx.updateTimelineShareData({
                  title: shareData.title,
                  desc: shareData.desc,
                  link: shareData.link,
                  imgUrl: shareData.imgUrl,
                  success: () => console.log("分享到朋友圈配置成功"),
                  fail: (err) => console.log("❌ 朋友分享配置失败",err),
                });
              isReady.value = true;
              console.log("微信 JSSDK 初始化成功 ✅");
            });
      })
  };

  return { isReady, initWeChatShare };
};
